<div class="alerts-page-container">
  <!-- Modern Header Section -->
  <div class="page-header">
    <div class="header-content">
      <div class="back-section" (click)="goBack()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Back</span>
      </div>
      <div class="header-info">
        <h1 class="page-title">Alerts Management</h1>
      </div>
    </div>
  </div>

  <!-- Modern Table Container -->
  <div class="table-container">
    <div class="table-header">
      <div class="table-title">
        <h2 class="section-title">All Alerts</h2>
        
      </div>
    </div>

    <!-- Modern Data Table -->
    <div class="data-table">
      <div class="table-header-row">
        <div class="header-cell store-col">Store</div>
        <div class="header-cell alert-col">Alert Details</div>
        <div class="header-cell type-col">
          <div class="filter-header">
            <span>Type</span>
            <button class="filter-btn" (click)="openTypesListPopup($event)" title="Filter by Type">
              FILTER
              <svg *ngIf="selectedTypeForAlert.length === 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="selectedTypeForAlert.length !== 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <!-- Filter Popup -->
          <div class="filter-popup" id="type_for-popup">
            <div class="popup-content">
              <div class="filter-option">
                <input name="uploaded_for" id="lowStock" type="checkbox" value="Low Stock" [checked]="selectedTypeForAlert.includes('Low Stock') ? true : false" (change)="onSelectType($event)">
                <label for="lowStock">Low Stock</label>
              </div>
              <div class="filter-option">
                <input name="uploaded_for" id="missing" type="checkbox" value="missing" [checked]="selectedTypeForAlert.includes('missing') ? true : false" (change)="onSelectType($event)">
                <label for="missing">Missing</label>
              </div>
            </div>
          </div>
        </div>
        <div class="header-cell date-col">
          <div class="filter-header">
            <span>Raised At</span>
            <button class="sort-btn" (click)="raisedAtSort()" title="Sort by Raised At">
              SORT
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6h10M6 10h4M8 14h0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="header-cell date-col">
          <div class="filter-header">
            <span>Resolved At</span>
            <button class="sort-btn" (click)="resolvedSort()" title="Sort by Resolved At">
              SORT
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6h10M6 10h4M8 14h0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="header-cell status-col">
          <div class="filter-header">
            <span>Status</span>
            <button class="filter-btn" (click)="openStatusListPopup($event)" title="Filter by Status">
              FILTER
              <svg *ngIf="selectedStatusForAlert.length === 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="selectedStatusForAlert.length !== 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <!-- Filter Popup -->
          <div class="filter-popup" id="status_for-popup">
            <div class="popup-content">
              <div class="filter-option">
                <input name="uploaded_for" id="open" type="checkbox" value="0" [checked]="selectedStatusForAlert.includes('0') ? true : false" (change)="onSelectStatus($event)">
                <label for="open">Open</label>
              </div>
              <div class="filter-option">
                <input name="uploaded_for" id="close" type="checkbox" value="1" [checked]="selectedStatusForAlert.includes('1') ? true : false" (change)="onSelectStatus($event)">
                <label for="close">Closed</label>
              </div>
            </div>
          </div>
        </div>
        <div class="header-cell actions-col">Actions</div>
      </div>

      <!-- Table Rows -->
      <div class="table-body">
        <div class="table-row" *ngFor="let alert of alerts">
          <div class="table-cell store-cell">
            <div class="store-info">
              <div class="store-name">{{ alert.store_name }}</div>
            </div>
          </div>
          <div class="table-cell alert-cell">
            <div class="alert-info">
              <div class="alert-title">
                {{ alert.cabinet_name ? alert.cabinet_name : (alert.product_name ? alert.product_name : 'N/A') }}
              </div>
            </div>
          </div>
          <div class="table-cell type-cell">
            <div class="type-badge" [ngClass]="'type-' + alert.status.toLowerCase().replace(' ', '-')">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M6 3V6L8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ alert.status }}</span>
            </div>
          </div>
          <div class="table-cell date-cell">
            <div class="date-info">
              <div class="date-value">{{ timestampFormat(alert.raised_at, "DD/MM/YYYY") }}</div>
              <div class="time-value">{{ timestampFormat(alert.raised_at, "HH:mm") }}</div>
            </div>
          </div>
          <div class="table-cell date-cell">
            <div class="date-info">
              <div class="date-value" *ngIf="alert.resolved_at">{{ timestampFormat(alert.resolved_at, "DD/MM/YYYY") }}</div>
              <div class="time-value" *ngIf="alert.resolved_at">{{ timestampFormat(alert.resolved_at, "HH:mm") }}</div>
              <div class="no-date" *ngIf="!alert.resolved_at">-</div>
            </div>
          </div>
          <div class="table-cell status-cell">
            <div class="status-container">
              <div class="status-badge" [ngClass]="alert.is_closed == 1 ? 'status-closed' : 'status-open'">
                <div class="status-dot"></div>
                <span>{{ alert.is_closed === 1 ? 'Closed' : 'Open' }}</span>
              </div>
              <div class="user-info" *ngIf="alert.is_closed == 1 && alert.user">
                <button class="info-btn" title="View details">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M7 3.5V7M7 10.5H7.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="user-tooltip">
                  <div class="tooltip-content">
                    <p class="tooltip-label">Alert Closed By</p>
                    <p class="tooltip-name">{{ alert.user.name }}</p>
                    <p class="tooltip-role">{{ alert.user.role }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-cell actions-cell">
            <div class="action-buttons">
              <button *ngIf="alert.is_closed == 0" class="action-btn close-btn" (click)="openDialog(alert)">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
                </svg>
                <span>Mark Closed</span>
              </button>
              <span *ngIf="alert.is_closed == 1" class="closed-indicator">Closed</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results State -->
    <div *ngIf="!alerts || alerts.length === 0" class="no-results">
      <div class="no-results-content">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" stroke="#e5e7eb" stroke-width="2"/>
          <path d="M32 20V32M32 44H32.01" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <h3 class="no-results-title">No alerts found</h3>
        <p class="no-results-text">There are currently no alerts to display</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container" *ngIf="paginationData.totalPage > 1">
    <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
  </div>
</div>

